// extracted by mini-css-extract-plugin
export default {"input":"SelectAvatar-module__input"};